import { CompareAndUpdateCandidateDetailsComponent } from "./compare-and-update-candidate-details.component";
export const CompareAndUpdateCandidateDetailsModule = angular
    .module('compareAndUpdateCandidateDetails', [])
    .component(CompareAndUpdateCandidateDetailsComponent.selector, CompareAndUpdateCandidateDetailsComponent.component)
    .name;
//# sourceMappingURL=compare-and-update-candidate-details.module.js.map